/* eslint-disable no-useless-escape */
import loader from '../common/loader';
import { isFunction, isArray, isObject } from '../common/base';
import cookie from '../common/cookie';
import { version } from '../common/config';
import Aegis from '@tencent/aegis-web-sdk';
/*
Milo前端监控(基于Aegis)
*/
// 内部成员变量-业务相关

var isInitOK = false;
var isLoadingTdm = false;
var loadTdmCb = [];
var oCurrentConfig = null;
var oExtraParams = {};
var aegisInstanse = null;
var isTdmLoad = false; // 内部成员变量-milojs相关

var aegisInstanseForMilo = null;
var arrInitMiloCb = [];
var arrInitReportCb = [];
var loadMiloStatus = 0;
var loadReportStatus = 0; // 获取当前域名对应的配置信息

/*
    {
    'lol.qq.com':{
        sMiloAegisId:'',//表示milo自身的监控，需要分散到域名
        sHash:''//sHash如果是空，则表示没有业务监控，如果非空，表示有业务监控，可用来做缓存
    }
    }
    */

var arrGetDomainListCb = [];
var oDomainConfig = null;
var iDomainConfigStatus = 0; // 0 not load. 1 pending. 2 loaded ok or fail
// fBeforeAegisReport
// beforeReport 触发的时候统一要执行的函数

var fBeforeAegisReport = function fBeforeAegisReport(log) {
  var uin = frontmonitor.getUin(); // 上报Tdm

  if (isTdmLoad && oCurrentConfig.sTdmId) {
    window.Tdm.reportEvents({
      events: [{
        srcId: 15002,
        eventName: 'ErrorLog',
        eventInfo: {
          s_from: location.href,
          s_uin: uin,
          s_itemId: oCurrentConfig.sAegisId,
          s_errlevel: log.level,
          s_errcontent: log.msg
        }
      }],
      success: function success(result) {
        console.info(result);
      },
      error: function error(errMessage) {
        console.error(errMessage);
      }
    });
  }
};

var getDomainListConfig = function getDomainListConfig(callback) {
  if (2 == iDomainConfigStatus) {
    isFunction(callback) && callback(oDomainConfig);
    return;
  }

  arrGetDomainListCb.push(callback);

  if (1 == iDomainConfigStatus) {
    return;
  }

  iDomainConfigStatus = 1;
  loader.loadScript('//ossweb-img.qq.com/images/js/milo_config_server/milo_monitor_alldomain.js').then(function (isLoad) {
    iDomainConfigStatus = 2;

    if (false !== isLoad) {
      oDomainConfig = window.Milo_Monitor_All_Domain && window.Milo_Monitor_All_Domain[location.host] || null;
    }

    while (arrGetDomainListCb.length) {
      var tmpCb = arrGetDomainListCb.shift();
      isFunction(tmpCb) && tmpCb(oDomainConfig);
    }
  })["catch"](function () {});
}; // 获取当前页面匹配到的监控配置文件


var getMonitorConfig = function getMonitorConfig(callback) {
  if (oCurrentConfig) {
    callback(oCurrentConfig);
    return;
  }

  getDomainListConfig(function (oDomainConfig) {
    // isOnlyMilo表示只是milo项目，不需要加载具体的域名下的配置文件
    if (oDomainConfig && 1 != oDomainConfig.isOnlyMilo) {
      loader.loadScript("//ossweb-img.qq.com/images/js/milo_config_server/milo_monitor_web_".concat(location.host, ".js")).then(function (isLoad) {
        if (false === isLoad) {
          callback(null);
        } else {
          var hostConfig = window.Milo_Monitor_Config;

          if (hostConfig) {
            var arrConfig = hostConfig.data;

            if (isArray(arrConfig)) {
              var currentUrl = location.href.substring(7);
              var currentConfig = null;

              if ('https:' == location.protocol) {
                currentUrl = location.href.substring(8);
              }

              for (var i = 0; i < arrConfig.length; i++) {
                if (!arrConfig[i].isOnline) {
                  continue;
                }

                var sUrl = arrConfig[i].url;

                if (currentUrl.length >= sUrl.length && 0 == currentUrl.indexOf(sUrl)) {
                  currentConfig = arrConfig[i];
                  break;
                } // 配置的是域名


                if (sUrl == location.host) {
                  currentConfig = arrConfig[i];
                  break;
                } // 配置的是父域名


                if (new RegExp("^([\\w\\-]+\\.)+".concat(sUrl, "$")).test(location.host)) {
                  currentConfig = arrConfig[i];
                  break;
                }
              }

              oCurrentConfig = currentConfig;
              callback(currentConfig);
            } else {
              callback(null);
            }
          }
        }
      })["catch"](function () {});
    } else {
      callback(null);
    }
  });
}; // isLogAboutMilo 判断该条日志是否是milojs逻辑相关


var isLogAboutMilo = function isLogAboutMilo(log) {
  var msg = log.msg || '';
  var isAbout = false;
  var arrAboutReg = [// eslint-disable-next-line no-useless-escape
  /((ossweb\-img\.qq\.com)|(game\.gtimg\.cn))\/images\/js\/(milo|(milo\_bundle)|mobile|(mobile\_bundle)|(mobile\_build))/ig];
  var arrNotAboutReg = [/(ossweb\-img\.qq\.com|game\.gtimg\.cn)\/images\/js\/(milo|milo\_bundle|mobile|mobile\_bundle|mobile\_build)\/util\/(jquery|zepto)\.js/ig]; // 先过滤掉黑名单影响

  for (var j = 0; j < arrNotAboutReg.length; j++) {
    msg = msg.replace(arrNotAboutReg[j], '');
  } // 白名单


  for (var i = 0; i < arrAboutReg.length; i++) {
    if (arrAboutReg[i].test(msg)) {
      isAbout = true;
      break;
    }
  }

  return isAbout;
};

var frontmonitor = {
  init: function init(callback, extraParams) {
    if (1 == loadReportStatus) {
      arrInitReportCb.push(callback);
      return;
    }

    if (2 == loadReportStatus) {
      isFunction(callback) && callback({
        oAegis: aegisInstanse,
        oTdm: window.Tdm
      });
      return;
    }

    loadReportStatus = 1;
    arrInitReportCb.push(callback);
    var self = this; // this.initForMilo();

    if (isInitOK) {
      isFunction(callback) && callback({
        oAegis: aegisInstanse,
        oTdm: window.Tdm
      });
      return;
    }

    oExtraParams = extraParams || {
      aegis: null,
      tdm: null
    };
    getMonitorConfig(function (currentConfig) {
      if (!currentConfig) {
        isInitOK = true;
        return;
      }

      if (currentConfig.sTdmId) {
        self.initTdm(function () {
          self.initAegis(function () {
            isInitOK = true;
            loadReportStatus = 2;

            while (arrInitReportCb.length) {
              var tmpCb = arrInitReportCb.shift();
              isFunction(tmpCb) && tmpCb({
                oAegis: aegisInstanse,
                oTdm: window.Tdm
              });
            }
          });
        });
      } else {
        self.initAegis(function () {
          isInitOK = true;
          loadReportStatus = 2;

          while (arrInitReportCb.length) {
            var tmpCb = arrInitReportCb.shift();
            isFunction(tmpCb) && tmpCb({
              oAegis: aegisInstanse
            });
          }
        });
      }
    });
  },
  // 初始化Aegis
  initAegis: function initAegis(callback) {
    var self = this;

    if (!oCurrentConfig) {
      callback(null);
      return;
    }

    if (aegisInstanse) {
      isFunction(callback) && callback(aegisInstanse);
    } else {
      var uin = self.getUin();
      var id = oCurrentConfig.sAegisId;
      var oInitAegisParams = {
        id: id,
        reportApiSpeed: false,
        reportAssetSpeed: false,
        pagePerformance: false,
        webVitals: false,
        onError: false
      }; // 自定义参数：

      var oExtra = isObject(oExtraParams.aegis) ? oExtraParams.aegis : {}; // 如果有uin

      if (uin) {
        oInitAegisParams.uin = uin;
      } // 静态资源测速


      if (1 == oCurrentConfig.iReportAssetsSpeed) {
        oInitAegisParams.reportAssetSpeed = true;
      } // 接口测速


      if (1 == oCurrentConfig.iReportCgiSpeed) {
        oInitAegisParams.reportApiSpeed = true;
      } // 页面测速 add by weiztang 202312


      if (1 == oCurrentConfig.iReportPagePerformance) {
        oInitAegisParams.pagePerformance = true;
      } // web vitals 测速 add by weiztang 202312


      if (1 == oCurrentConfig.iReportWebVitals) {
        oInitAegisParams.webVitals = true;
      } // 获取错误日志 add by weiztang 202312


      if (1 == oCurrentConfig.iReportOnError) {
        oInitAegisParams.onError = true;
      } // http/https过滤


      if ('all' != oCurrentConfig.sProtocolFilter) {
        if (location.protocol.substr(0, location.protocol.length - 1) != oCurrentConfig.sProtocolFilter) {
          callback();
          return;
        }
      } // 平台过滤


      if ('mobile' == oCurrentConfig.sPcMobileFilter) {
        callback();
        return;
      }
      /*
                自定义额外参数相关:
            */
      // 如果有onReport


      if (isFunction(oExtra.onReport)) {
        oInitAegisParams.onReport = function () {
          // 一系列初始化动作
          return oExtra.onReport.call(null, arguments);
        };
      } // 如果有beforeReport


      if (isFunction(oExtra.beforeReport)) {
        oInitAegisParams.beforeReport = function (log) {
          // 只上报milojs无关的报错
          if (isLogAboutMilo(log)) {
            return false;
          }

          fBeforeAegisReport(log, false); // 一系列初始化动作

          return oExtra.beforeReport.call(null, arguments);
        };
      } else {
        oInitAegisParams.beforeReport = function (log) {
          // 只上报milojs无关的报错
          if (isLogAboutMilo(log)) {
            return false;
          }

          fBeforeAegisReport(log, false);
        };
      }

      aegisInstanse = new Aegis(oInitAegisParams);
      isFunction(callback) && callback(aegisInstanse);
    }
  },
  getAegisInstance: function getAegisInstance(callback) {
    this.init(function (e) {
      isFunction(callback) && callback(e.oAegis);
    });
  },
  // 初始化Tdm
  initTdm: function initTdm(callback) {
    var self = this;

    if (!oCurrentConfig) {
      callback(null);
      return;
    }

    if (isTdmLoad) {
      isFunction(callback) && callback(window.Tdm);
    } else {
      var uin = self.getUin();
      var _oCurrentConfig = oCurrentConfig,
          sTdmId = _oCurrentConfig.sTdmId;
      this.loadTdm(function (Tdm) {
        Tdm.init({
          env: 'cn',
          appId: Number(sTdmId),
          appVer: "".concat(version),
          userId: uin,
          channel: 'milo'
        }).then(function () {
          // isInitTdm=true;
          isFunction(callback) && callback();
        })["catch"](function (errMessage) {
          console.error(errMessage);
        });
      });
    }
  },
  // 获取tdm引用
  loadTdm: function loadTdm(callback) {
    if (window.Tdm) {
      isFunction(callback) && callback(window.Tdm);
    } else {
      loadTdmCb.push(callback);

      if (isLoadingTdm) {
        return;
      }

      isLoadingTdm = true;
      loader.loadScript('https://game.gtimg.cn/images/js/tdm/tdm.js').then(function (isLoad) {
        if (!isLoad) {
          return;
        }

        isTdmLoad = true;

        while (loadTdmCb.length) {
          var cb = loadTdmCb.shift();
          isFunction(cb) && cb(window.Tdm);
        }
      });
    }
  },
  getUin: function getUin() {
    var acctype = cookie.get('acctype');
    var uin = '';
    var appid = cookie.get('appid');

    if (acctype) {
      uin = cookie.get('openid');
    } else {
      acctype = 'pt';
      uin = cookie.get('uin');
    }

    if ('pt' == acctype) {
      if (uin) {
        return "".concat(acctype, "-").concat(uin);
      }
    } else if (/^(wx|qc|wg)$/.test(acctype)) {
      if (uin && appid) {
        return "".concat(acctype, "-").concat(appid, "-").concat(uin);
      }

      if (uin) {
        return "".concat(acctype, "-unknown-").concat(uin);
      }
    }

    return '';
  } // 只监控milo相关的数据
  // initForMilo(callback) {
  //   const self = this;
  //   // loadStatus=1 pending
  //   if (1 == loadMiloStatus && isFunction(callback)) {
  //     arrInitMiloCb.push(callback);
  //     return;
  //   }
  //   // loadStatus=2 loadOK
  //   if (2 == loadMiloStatus) {
  //     isFunction(callback) && callback({
  //       oAegis: aegisInstanseForMilo,
  //     });
  //     return;
  //   }
  //   // loadStatus=0
  //   loadMiloStatus = 1;// pending
  //   arrInitMiloCb.push(callback);
  //   getDomainListConfig((oDomainConfig) => {
  //     if (!oDomainConfig || !oDomainConfig.config || !oDomainConfig.config.sAegisId) {
  //       return;
  //     }
  //     const { sAegisId } = oDomainConfig.config;
  //     const uin = self.getUin();
  //     const oInitParams = {
  //       id: sAegisId,
  // reportApiSpeed: false,
  // reportAssetSpeed: false,
  // pagePerformance: false,
  // webVitals: false,
  // onError: true,
  //       beforeReport(log) {
  //         // 只上报milojs自身相关的报错
  //         if (!isLogAboutMilo(log)) {
  //           return false;
  //         }
  //       },
  //     };
  //     if (uin) {
  //       oInitParams.uin = uin;
  //     }
  //     aegisInstanseForMilo = new Aegis(oInitParams);
  //     loadMiloStatus = 2;// loadOK
  //     // isInitMiloOK=true;
  //     while (arrInitMiloCb.length) {
  //       const tmpCb = arrInitMiloCb.shift();
  //       isFunction(tmpCb) && tmpCb({
  //         oAegis: aegisInstanseForMilo,
  //       });
  //     }
  //   });
  // },

};
export default frontmonitor;